'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:core:HBNBVersion');
}

var _invoke = require('../invoke');

/**
 * 获取桥协议版本
 *
 * 支持版本
 * + iHotel/6.1+
 * + HBNB/?
 *
 * @memberof core
 * @static
 * @name HBNBVersion
 * @return {Promise<version>}
 * @example
 *  hbnb.core.HBNBVersion()
 *      .then(function(version) {
 *      });
 */

module.exports = function() {
    if (process.env.NODE_ENV !== 'production') {
        debug('called');
    }

    var p = new Promise(function(resolve, reject) {
        _invoke('core', 'hbnb_version', {
            callback: function(version) {
                if (process.env.NODE_ENV !== 'production') {
                    debug('version is %j', version);
                }
                if (version && version.version) {
                    resolve(version.version);
                } else {
                    reject();
                }
            }
        });
    });
    return p;
};



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@hfe/hbnb/core/hbnb_version.js
// module id = 571
// module chunks = 0